<template lang="pug">
.onboarding-step
  .onboarding-step-header
    h1 Invite Your Team
    p The more the merrier. You don't want to do this all alone do you?
  .onboarding-step-content
    .row.center
      .col.max
        form(@submit.prevent="submit")
          AlertBox(v-if="error", type="danger", :text="error")
          div.form-field(:class="{error: $v.form.email.$error, 'error-required': !$v.form.email.required}")
            label
              h6 Email Address
              input(v-model="$v.form.email.$model", type="email", placeholder="john@example.com")
          div.form-field.no-margin
            .row.gap-1
              .col
                SubmitButton(label="Invite", :formState="formState")
              .col
                button.button(type="button", @click="skip") Later
      .col.max.animation
        LottieAnimation(svg="onboarding_1", :width="200", :height="200")
</template>

<script>
  import LottieAnimation from '@/components/helpers/LottieAnimation'
  import { required, email } from 'vuelidate/lib/validators'
  import { form } from '@/mixins/form'

  export default {
    name: 'OnboardingInvite',
    mixins: [form],
    components: {
      LottieAnimation
    },
    beforeMount () {
    },
    data () {
      return {
        formState: 'initial',
        form: {
          email: ''
        },
        error: null
      }
    },
    validations: {
      form: {
        email: {
          required,
          email
        }
      }
    },
    computed: {
    },
    methods: {
      submit () {
        if (this.__formInvalid()) return
        this.formState = 'pending'
        this.$store.dispatch('postInvites', this.form).then(() => {
          this.formState = 'success'
          this.form = {
            email: ''
          }
          this.$v.$reset()
          this.$emit('next')
        }, error => {
          console.log(error)
          this.error = error
          this.formState = 'initial'
        })
      },
      skip () {
        this.$emit('next')
      }
    }
  }
</script>

<style lang="stylus" scoped>
.onboarding-step
  border $border-default
  .onboarding-step-header
    background-color $background-color
    border-bottom $border-default
    padding $spacing-3
    text-align center
    h1
      font-size 22px
      margin-bottom 30px
    p
      color $text-light
  .onboarding-step-content
    padding $spacing-3
  .animation
    +for_breakpoint(mobile)
      display none
</style>
